import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './ReadOnly.styles';

const propTypes = {
  classes: PropTypes.object.isRequired,
  formDefinition: PropTypes.object.isRequired,
};

// Informational answer carried over from a previous order; never editable
const ReadOnly = ({ classes, formDefinition, inputStyle }) => {
  const answerText = formDefinition.answers
    .map(a => a.text ?? a.value)
    .filter(Boolean)
    .join(', ');

  return (
    <Typography
      key={`${formDefinition.orderFormHeaderId}-${formDefinition.formDefinitionId}`}
      variant="body1"
      className={classes.readOnly}
      style={inputStyle}
    >
      {answerText || 'None'}
    </Typography>
  );
};

ReadOnly.propTypes = propTypes;
export default withStyles(styles)(ReadOnly);
